var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_8",
    "data-name": "Component 37 \\u2013 8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18.75,
    viewBox: "0 0 21 18.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M8.25,6.75A3.75,3.75,0,1,1,12,10.5,3.75,3.75,0,0,1,8.25,6.75Zm7.5,3a3,3,0,1,1,3,3,3,3,0,0,1-3-3Zm-13.5,0a3,3,0,1,1,3,3,3,3,0,0,1-3-3Zm4.06,5.367a6.75,6.75,0,0,1,12.4,4.381.75.75,0,0,1-.372.568,12.765,12.765,0,0,1-12.674,0,.75.75,0,0,1-.372-.568,6.787,6.787,0,0,1,1.019-4.38Z",
    transform: "translate(-1.5 -3)",
    fill: "#293139",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M5.082,14.254a8.287,8.287,0,0,0-1.308,5.135,9.687,9.687,0,0,1-1.764-.44l-.115-.04a.563.563,0,0,1-.373-.487l-.01-.121a3.75,3.75,0,0,1,3.57-4.047Zm15.144,5.135a8.287,8.287,0,0,0-1.308-5.135,3.75,3.75,0,0,1,3.57,4.047l-.01.121a.563.563,0,0,1-.373.486l-.115.04A9.628,9.628,0,0,1,20.226,19.389Z",
    transform: "translate(-1.5 -3)",
    fill: "#293139"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.03cc3f6a77adaa5b91aebfb0e92e5fff.svg";
export { ForwardRef as ReactComponent };